import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { LeftMenuComponent } from '../../menu/left-menu/left-menu.component';
import { PodsListComponent } from '../pods-list/pods-list.component';
import { ApplicationSettingsComponent } from '../application-settings/application-settings.component';

@Component({
  selector: 'modernization-application-admin',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss'],
  imports: [CommonModule, MaterialModule, LeftMenuComponent, ApplicationSettingsComponent, PodsListComponent]
})
export class ApplicationComponent implements OnInit {
  selectedTabIndex = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const currentPath = this.route.routeConfig?.path?.toLowerCase();
    const tab = this.route.snapshot.queryParamMap.get('tab')?.toLowerCase();

    if (currentPath === 'pods-list' || tab === 'pods-list') {
      this.selectedTabIndex = 1;
    }
  }

  onTabChange(index: number): void {
    this.selectedTabIndex = index;

    if (index === 1) {
      this.router.navigate(['/admin/application'], { queryParams: { tab: 'pods-list' } });
      return;
    }

    this.router.navigate(['/admin/application']);
  }
}